import React, { useState } from "react";
import SellerType from "../UI/StoreManagerForm/SellerType";
import UploadDocuments from "../UI/StoreManagerForm/UploadDocuments";
import RegisterPricingPlan from "../UI/StoreManagerForm/RegisterPricingPlan";

const StoreManager = () => {
  const [showPopup, setShowPopup] = useState(false);

  const [currentStep, setCurrentStep] = useState(1);

  const handleNext = () => {
    setCurrentStep((prevStep) => prevStep + 1);
  };

  const handlePrev = () => {
    setCurrentStep((prevStep) => prevStep - 1);
  };

  const steps = [
    { title: "Select Seller Type", content: <SellerType /> },
    { title: "Step 2", content: <UploadDocuments /> },
    { title: "Step 3", content: <RegisterPricingPlan /> },
  ];

  return (
    <div className="flex flex-col justify-center items-center h-screen">
      <button
        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
        onClick={() => setShowPopup(true)}
      >
        Store Manager
      </button>
      {showPopup && (
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 overflow-auto h-full w-full flex justify-center items-center">
          <div className="max-w-2xl mx-auto p-6 bg-white rounded shadow">
            <h2 className="text-2xl font-bold mb-4">
              Welcome to Store Manager
            </h2>
            <p className="mb-6">
              Efficiently manage your products, orders, inquiries, and payments
              all in one place with - Store Manager
            </p>

            <div className="mb-4 flex justify-between">
              {steps.map((step, index) => (
                <div
                  key={index}
                  className={`flex-1 p-2 ${
                    currentStep === index + 1 ? "font-bold" : ""
                  }`}
                >
                  {step.title}
                </div>
              ))}
            </div>

            <div className="mb-4">{steps[currentStep - 1].content}</div>

            <div className="flex justify-between">
              <button
                onClick={handlePrev}
                disabled={currentStep === 1}
                className="px-4 py-2 bg-gray-300 rounded disabled:opacity-50"
              >
                Previous
              </button>
              <button
                onClick={handleNext}
                disabled={currentStep === steps.length}
                className="px-4 py-2 bg-orange-500 text-white rounded"
              >
                Next
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default StoreManager;
